<template>
  <div
    id="product-filter-web"
    class="product-filter-web-container flex-column-layout"
  >
    <BreadCrumbs
      :category-filters="filterData.categoryFilters"
      :slug-title="slugTitle"
    />
    <UiDivider :type="'primary'" />
    <CategoryTree
      :category-filters="filterData.categoryFilters"
      :slug-title="slugTitle"
    />
    <UiDivider :type="'primary'" />
    <AllFilterContainer
      :brand-filters="filterData.brandFilters"
      :price-range-filter="filterData.priceRangeFilter"
      :other-filters="filterData.otherFilters"
      :type-filters="filterData.typeFilters"
    />
    <UiDivider :type="'primary'" />
    <ScrollToTopButton />
  </div>
</template>

<script lang="ts" setup>
import UiDivider from '@sephora-asia/ui-divider'
import BreadCrumbs from './bread-crumbs.vue'
import CategoryTree from './category-tree.vue'
import AllFilterContainer from './all-filter-container.vue'
import ScrollToTopButton from './scroll-to-top-button.vue'
import type {
  BrandFilters,
  CategoryFilters,
  OtherFilters,
  PriceRangeFilter,
  TypeFilters,
} from '~/types/api/data/product/filter/filter.types'

defineProps<{
  filterData: {
    categoryFilters: CategoryFilters[]
    brandFilters: BrandFilters[]
    priceRangeFilter: PriceRangeFilter
    otherFilters: OtherFilters[]
    typeFilters: TypeFilters[]
  }
}>()

const { slugUrl } = useBaseRoutes()
const { campaignName } = usePageMetaStore()

const slugTitle = computed(() => campaignName ?? slugUrl.value)
</script>

<style lang="scss">
.product-filter-web-container {
  width: 312px; // Fixed width specification from figma
  height: 100%;
  overflow-y: auto;
}

.flex-column-layout {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
</style>
